
import { EMPTY_VALUES } from '../../../../../../Apis/functions';
import React from 'react';
import CustomChip from '../../../../../../components/CustomChip';
import { colors } from '../../../../../../enums/colors';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle: Full Stack Developer - IBL
 * @Email: clopez@ibl.mx
 *
 */
const BannerComponentUser = ({ title, nameChip, variantChip = "compact", icon }) => {
    return (
        <div className={'d-flex align-items-center'}>
            <div>{icon}</div>
            <p className={'fs-14px ibl-font-w-400 font-color-general-950 m-2'}>
                {title || EMPTY_VALUES.DEFAULT}
            </p>
            <div className='vertical-separator-shades-950' />
            <CustomChip
                background={colors.secondary100}
                fontColor={colors.secondary700}
                borderColor={colors.secondary150}
                legend={nameChip}
                variant={variantChip}
            />
        </div>
    );
}
export default BannerComponentUser;
